export default __webpack_public_path__ + "static/media/Letters3_15.4ad49c76.png";